import { CustomIconProps } from './index';

export const ErrorIcon = ({ color }: CustomIconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            fill="none"
            viewBox="0 0 24 24">
            <circle
                cx={12}
                cy={12}
                r={11}
                fill="#fff"
                stroke={color || 'black'}
                strokeWidth={2}
            />
            <path fill={color || 'black'} d="M11 6h2v8h-2zm0 10h2v2h-2z" />
        </svg>
    );
};
